module.exports = __webpack_public_path__ + "img/hr-heat-pipe-t-1.6a498c91.png";